import React from "react";
import { Link } from "react-router-dom";
import "../css/privacy.scss";

const questions = [
  ["When will my order be dispatched?", "Most orders are prepared within 1–3 business days. Tracking is sent to the email provided at checkout when the parcel leaves our facility."],
  ["How much is shipping?", "Standard tracked shipping is a fixed USD $9.99 for every accepted destination shown at checkout."],
  ["Which countries can I select?", "Available destinations are listed in the checkout country selector. Destinations subject to applicable trade or delivery restrictions are not offered."],
  ["Can I change or cancel an order?", "Email globe@ioomparade.online as soon as possible. We will try to help before packing begins, but changes cannot be guaranteed after dispatch."],
  ["What if an item arrives damaged?", "Contact us within 7 days of delivery with your order reference and clear photos of the item and packaging so we can review the issue."],
  ["Do you store card details?", "No. Card details are entered only on the secure payment provider page and are not collected by the ioomparade checkout form."],
  ["How do returns work?", "Eligible unused items can be requested for return within 30 days. Review the Returns Policy and contact us before sending anything back."],
  ["How can I reach ioomparade?", "Email globe@ioomparade.online. We do not provide telephone support."],
];

function Faqs() {
  return (
    <main className="ink-info-page ink-info-page--privacy">
      <div className="ink-info-page__inner">
        <header className="ink-info-page__header">
          <p className="ink-info-page__eyebrow">Helpful information</p>
          <h1>Frequently Asked Questions</h1>
          <p className="ink-info-page__lead">
            Quick answers about orders, delivery, payment, and returns.
          </p>
        </header>
        <div className="privacy-sections">
          {questions.map(([question, answer], index) => (
            <section className="privacy-section" key={question}>
              <span className="privacy-section__number" aria-hidden="true">
                {String(index + 1).padStart(2, "0")}
              </span>
              <div>
                <h2>{question}</h2>
                <p>{answer}</p>
              </div>
            </section>
          ))}
        </div>
        <section className="privacy-contact">
          <div>
            <p className="ink-info-page__kicker">Need more help?</p>
            <h2>Send us your question</h2>
          </div>
          <Link className="ink-info-page__button" to="/contact">Contact ioomparade</Link>
        </section>
      </div>
    </main>
  );
}

export default Faqs;
